import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { SessionService } from '@app/session/session.service';
import { getServerConfig } from '@app/origami-api/server-config';
import { TopicUtils } from '@app/origami-api/utils/topic-utils';
import { FieldNames } from '@app/origami-api/constants/field-names';
import { LocalStorageKeys } from '@app/services/local-storage.service';
import { BuildProps } from '@app/origami-api/build-props';
import { AboutRoomViewerComponent } from './about-room-viewer.component';
import { RouteCheckers } from '@app/pages/main/route-checkers';

declare const appVersion: string;

@Component({
  standalone: false,
  selector: 'ti-about-room-window',
  templateUrl: './about-room-window.component.html',
  styleUrls: ['./about-room-window.component.sass'],
})
export class AboutRoomWindowComponent implements OnInit {
  readonly localStorageKeys = LocalStorageKeys;
  readonly strings = tiStrings.app.misc;

  @Output() close = new EventEmitter();

  userName: string;
  needHelpText: string;
  contactNumber: string;
  inbox: string;
  ssuInbox: string;
  communicationInbox: string;
  domainAddress: string;
  contactNumberText: string;
  inboxText: string;
  showEditor = false;
  showInfo = false;
  isLoading = false;
  appVersion = appVersion || BuildProps.OrigamiBuildNumber || '0.0.0.0';

  @ViewChild(AboutRoomViewerComponent) private viewer: AboutRoomViewerComponent;
  private sponsorDomainAddress: string;

  constructor(private sessionService: SessionService) {
    this.contactNumberText = this.strings.studyContactNumber;
    this.inboxText = this.strings.roomInbox;

    this.appVersion = this.sessionService.actualAppVersion || BuildProps.OrigamiBuildNumber || '0.0.0.0';

    this.userName =
      this.sessionService.user && this.sessionService.user.details ? this.sessionService.user.details.FullName : '';
  }

  public onClose() {
    this.close.emit();
  }

  ngOnInit() {
    this.updateContactInfo();
    if (!RouteCheckers.isTemplateSite(this.sessionService)) {
      this.updateSponsorInfo();
    }
  }

  onEditMode(editMode: boolean) {
    this.showEditor = editMode;
  }

  cancel() {
    this.viewer.cancel();
  }

  save() {
    this.viewer.save();
  }

  private updateContactInfo() {
    this.needHelpText = this.sessionService.settings.general.general.studyContactNumberHelpText.get();
    this.contactNumber = this.sessionService.settings.general.general.studyContactNumber.get();
    this.domainAddress =
      this.sponsorDomainAddress || this.sessionService.domain.settings.general.inbox.domainAddress.get();
    this.inbox =
      this.domainAddress && this.sessionService.settings.general.inbox.enableInbox.get()
        ? this.sessionService.settings.general.inbox.inboxEmail.get()
        : '';

    this.ssuInbox =
      this.domainAddress &&
      (this.sessionService.settings.general.module.enableSSU.get()
        ? this.sessionService.settings.general.inbox.enableSsuInbox.get()
          ? this.sessionService.settings.general.inbox.ssuInboxEmail.get()
          : ''
        : '');
    this.communicationInbox =
      this.domainAddress && this.sessionService.settings.general.inbox.enableCommunicationInbox.get()
        ? this.sessionService.settings.general.inbox.communicationEmail.get()
        : '';

    this.showInfo = !!(
      (this.contactNumber && this.contactNumberText) ||
      (this.inbox && this.inboxText) ||
      this.ssuInbox ||
      this.communicationInbox
    );
  }

  private updateSponsorInfo() {
    this.sessionService.room.getCurrentSponsor().subscribe((sponsor) => {
      if (
        getServerConfig().isMultitenantInstance &&
        sponsor &&
        TopicUtils.getTopicFieldValue(sponsor, FieldNames.Sponsor.UseSponsorInboxSettings)
      ) {
        this.sponsorDomainAddress = TopicUtils.getTopicFieldValue(sponsor, FieldNames.Sponsor.InboxEmailDomain);
        this.updateContactInfo();
      }
    });
  }
}
